const HTTP_URL_REGEX = /^https?:\/\/(.*$)/i;
const HTTP_PROTOCOL_REGEX = /^(https?)/i;

export function normalizeAll(normalizers) {
  return function(value, previousValue, allValues, previousAllValues) {
    let currentValue = value;
    normalizers.forEach(normalizer => {
      if (typeof normalizer === 'function') {
        currentValue = normalizer(currentValue, previousValue, allValues, previousAllValues);
      }
    });
    return currentValue;
  };
}

export function upperCase(value) {
  return value && value.toUpperCase();
}

export function lowerCase(value) {
  return value && value.toLowerCase();
}

export function trim(value) {
  return value && value.trim();
}

export function noSpaces(value) {
  return value && value.replace(/\s/g, '');
}

export function normalizeURL(url) {
  if (!url) {
    return '';
  }

  const hasProtocol = url.match(HTTP_PROTOCOL_REGEX);
  if (!hasProtocol) {
    return `https://${url}`;
  }

  const match = url.match(HTTP_URL_REGEX);
  if (hasProtocol && !match) {
    return '';
  }

  return url;
}



// WEBPACK FOOTER //
// ./src/site-render/src/lib/normalize.js